import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { UserProvider } from "./context/UserContext";
import { ConfigProvider } from "./context/ConfigContext";
import ScrollToTop from "./helpers/ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60 * 5,
    },
  },
});

root.render(
  <React.StrictMode>
    <ConfigProvider>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <Router>
            <ScrollToTop />
            <App />
          </Router>
        </UserProvider>
      </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>
);
